<template>
  <div>
    <div class="section-css">
      <div style="width:100%;display: flex;">
        <div>
          <ChampsSection
            :indexSection="indexSection"
          />
        </div>
        <div style="margin-left: auto; order: 2;">
          <BlocButtonsSection :isActive="isActive" :indexSection="indexSection" />
        </div>
      </div>
    </div>
    <!-- modal -->
    <b-modal
      :active="isActive"
      :width="640">
      <PopupDragSection />
    </b-modal>

  </div>
</template>
<script>
import BlocButtonsSection from './BlocButtonsSection'
import ChampsSection from '@/components/question/section/ChampsSection'
import PopupDragSection from '@/components/popup/PopupDragSection'
import EventBus from '@/eventBus'

export default {
  name: 'BlocGabaritSection',
  props: {
    indexSection: Number,
    required: true
  },
  data () {
    return {
      dragDisabled: true,
      isActive: false
    }
  },
  components: {
    ChampsSection,
    PopupDragSection,
    BlocButtonsSection
  },
  created () {
    EventBus.$on('is-active-popup-drag', this.isActivePopupDrag)
  },
  beforeDestroy () {
    EventBus.$off('is-active-popup-drag')
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    isActivePopupDrag (params) {
      this.sendMessageToParent('scrollToTop')
      switch (params.type) {
        case 'openPopup' :
          if (params.index === this.indexSection) this.isActive = true
          break
        case 'closePopup':
          this.isActive = false
          break
      }
    },
    parentDragOn () {
      this.$store.commit('INDEX_SECTION_DRAG_HISTORY', {
        indexSection: this.indexSection, indexQuestion: this.indexQuestion
      })
      this.$emit('dragDisabledSection', false)
    },
    parentDragOff () {
      this.$emit('dragDisabledSection', true)
    }
  }
}
</script>
<style scoped>
.section-css {
  padding:5px;
  background: #424A60;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/question/section/BlocGabaritSection.vue